import * as React from 'react'

import { Channel, GroupChannel } from '@/types/group-channel.type'

export function useDialogState() {
  // Group dialog states
  const [editGroupDialogOpen, setEditGroupDialogOpen] = React.useState(false)
  const [createGroupDialogOpen, setCreateGroupDialogOpen] = React.useState(false)
  const [deleteGroupDialogOpen, setDeleteGroupDialogOpen] = React.useState(false)
  const [selectedGroup, setSelectedGroup] = React.useState<GroupChannel | null>(null)

  // Channel dialog states
  const [editChannelDialogOpen, setEditChannelDialogOpen] = React.useState(false)
  const [createChannelDialogOpen, setCreateChannelDialogOpen] = React.useState(false)
  const [deleteChannelDialogOpen, setDeleteChannelDialogOpen] = React.useState(false)
  const [selectedChannel, setSelectedChannel] = React.useState<Channel | null>(null)
  const [selectedGroupForChannel, setSelectedGroupForChannel] = React.useState<GroupChannel | null>(null)

  const handleEditGroup = React.useCallback((group: GroupChannel) => {
    setSelectedGroup(group)
    setEditGroupDialogOpen(true)
  }, [])

  const handleDeleteGroup = React.useCallback((group: GroupChannel) => {
    setSelectedGroup(group)
    setDeleteGroupDialogOpen(true)
  }, [])

  const handleAddNewChannel = React.useCallback((group: GroupChannel | null) => {
    setSelectedGroupForChannel(group)
    setCreateChannelDialogOpen(true)
  }, [])

  const handleEditChannel = React.useCallback((channel: Channel) => {
    setSelectedChannel(channel)
    setEditChannelDialogOpen(true)
  }, [])

  const handleDeleteChannel = React.useCallback((channel: Channel) => {
    setSelectedChannel(channel)
    setDeleteChannelDialogOpen(true)
  }, [])

  return {
    // Group dialog state
    editGroupDialogOpen,
    setEditGroupDialogOpen,
    createGroupDialogOpen,
    setCreateGroupDialogOpen,
    deleteGroupDialogOpen,
    setDeleteGroupDialogOpen,
    selectedGroup,
    setSelectedGroup,

    // Channel dialog state
    editChannelDialogOpen,
    setEditChannelDialogOpen,
    createChannelDialogOpen,
    setCreateChannelDialogOpen,
    deleteChannelDialogOpen,
    setDeleteChannelDialogOpen,
    selectedChannel,
    setSelectedChannel,
    selectedGroupForChannel,

    // Handlers
    handleEditGroup,
    handleDeleteGroup,
    handleAddNewChannel,
    handleEditChannel,
    handleDeleteChannel,
  }
}
